import styled from "styled-components";
import { Image } from "@commonlibs";

export const RoleSelectResourceImage = styled(Image)`
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
`;
